import { RetailerPartnerType } from '../enum/index.js';
const config = {
    type: RetailerPartnerType.TARGET,
    baseURI: 'https://www.target.com/occ?fft=PICKUP&afid=MEREDITH'
};
export default config;
